import TitledText from "@coworker/apprestructured/src/task-management/components/TitledText/TitledText";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import { useTranslation } from "@coworker/locales";

export type TitledTextFieldViewerFragmentConfigProps = {
  title: string;
  field: string;
};

type TitledTextFieldViewerFragmentProps = {
  configProps: TitledTextFieldViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function TitledTextFieldViewerFragment({
  configProps,
  commonProps,
}: TitledTextFieldViewerFragmentProps) {
  const { field, title } = configProps;
  const { task } = commonProps;
  const text = getByPath<string>(task, field);

  const { t } = useTranslation();

  if (isLoading(text) || text.length === 0) {
    return null;
  }

  return <TitledText title={t(title)} text={t(text)} />;
}

export default TitledTextFieldViewerFragment;
